/**
 * @generated SignedSource<<bc1f4d3983c8c5d5efc3b2decde08ac7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getCreatorsAccordionTabs_storyTellingTab$data = {
  readonly contentBodyText: string;
  readonly contentHeader: string | null;
  readonly tabType: string;
  readonly " $fragmentType": "getCreatorsAccordionTabs_storyTellingTab";
};
export type getCreatorsAccordionTabs_storyTellingTab$key = {
  readonly " $data"?: getCreatorsAccordionTabs_storyTellingTab$data;
  readonly " $fragmentSpreads": FragmentRefs<"getCreatorsAccordionTabs_storyTellingTab">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getCreatorsAccordionTabs_storyTellingTab"
};

(node as any).hash = "0f621198627eea3844a605cb28ba6a6c";

export default node;
